import React, { useMemo } from "react"
import { Tag, Typography } from "antd"
import { ISapImportValidationError } from "@/types"

const { Text, Title } = Typography

interface Props {
  requiredFields?: string[]
  validationErrors?: ISapImportValidationError[]
}

const SapImportValidationSummary: React.FC<Props> = ({
  requiredFields = [],
  validationErrors = [],
}) => {
  const groupedErrors = useMemo(() => {
    const groups = new Map<number, string[]>()

    validationErrors.forEach((error) => {
      const rowNumber = Number(error.row_number) || 0
      const fieldLabel = error.field_label || error.field_key
      const currentFields = groups.get(rowNumber) || []

      if (!currentFields.includes(fieldLabel)) {
        currentFields.push(fieldLabel)
      }

      groups.set(rowNumber, currentFields)
    })

    return Array.from(groups.entries()).sort((a, b) => a[0] - b[0])
  }, [validationErrors])

  if (!validationErrors.length) {
    return null
  }

  return (
    <div
      style={{
        margin: 16,
        padding: 16,
        border: "1px solid #ffe58f",
        background: "#fffbe6",
        borderRadius: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          alignItems: "flex-start",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Title level={5} style={{ margin: 0, color: "#ad6800" }}>
            Mandatory fields are incomplete
          </Title>
          <Text style={{ color: "#8c6b1f" }}>
            Please complete the required fields listed below before submitting
            this import.
          </Text>
        </div>

        {requiredFields.length ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {requiredFields.map((field) => (
              <Tag
                key={field}
                color="gold"
                style={{ marginRight: 0, marginBottom: 0 }}
              >
                {field}
              </Tag>
            ))}
          </div>
        ) : null}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            width: "100%",
          }}
        >
          {groupedErrors.map(([rowNumber, fields]) => (
            <div
              key={rowNumber}
              style={{
                padding: "8px 12px",
                background: "#ffffff",
                border: "1px solid #ffe7ba",
                borderRadius: 8,
              }}
            >
              <Text strong style={{ color: "#d46b08" }}>
                {`Row ${rowNumber}`}
              </Text>
              <Text style={{ color: "#595959", marginLeft: 8 }}>
                {fields.join(", ")}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SapImportValidationSummary
